import React from 'react'
import LogoutBoxLineIcon from 'remixicon-react/LogoutBoxLineIcon'
import LoginBoxLineIcon from 'remixicon-react/LoginBoxLineIcon'
import ErrorWarningFillIcon from 'remixicon-react/ErrorWarningFillIcon'
import useUser from '@hooks/processor/useUser'
import XArrowIcon from '@UI/XArrowIcon'
import styles from './index.scss'
import Stepper from '@components/Stepper'
import Button from '@UI/antd/Button/Button'
import Popover from '@UI/antd/Popover/Popover'

interface IControllerFooterDesktop {
    nextDisable?: boolean
    stepArray?: {
        title: string
        route: string
    }[]
    hasSkip: boolean
    hasBack: boolean
    activeStep: number
    nextIsFetching?: boolean
    leaveText?: string
    nextText: string
    onNext: () => any
    onBack: () => any
    onLeave: () => any
    onSkip: () => any
    hasLeave: boolean
    i18n?: any
    errorText?: string
    additionalText?: string
    nextIsSubmit?: boolean
}

function ControllerFooterDesktop(props: IControllerFooterDesktop) {
    const {
        onNext,
        onBack,
        onLeave,
        onSkip,
        hasSkip,
        hasBack,
        activeStep,
        stepArray = [],
        nextDisable,
        nextIsFetching,
        leaveText,
        nextText,
        hasLeave,
        i18n,
        errorText = '',
        additionalText = '',
        nextIsSubmit = false
    } = props
    const { appDirection } = useUser()
    const nextButton = (
        <Button
            loading={nextIsFetching}
            id={`submit-${stepArray?.[activeStep]?.title?.replaceAll(' ', '')}`}
            // disabled={nextDisable}
            typeButton="primary-solid"
            className={nextDisable ? styles.disabled : ''}
            htmlType={nextIsSubmit ? 'submit' : 'button'}
            onClick={() => {
                if (!nextDisable && !nextIsSubmit) {
                    onNext()
                }
            }}
        >
            {nextText || i18n?.General?.Next}
            {errorText && <ErrorWarningFillIcon />}
        </Button>
    )
    return (
        <div className={`${styles['controller-footer']} ${hasLeave ? '' : styles['controller-footer__reverse']}`}>
            {hasLeave && (
                <Button
                    typeButton="secondary-outlined"
                    icon={appDirection === 'rtl' ? <LoginBoxLineIcon /> : <LogoutBoxLineIcon />}
                    onClick={onLeave}
                >
                    {leaveText || i18n?.General?.Leave}
                </Button>
            )}
            <Stepper absoluteStyleContainer current={activeStep} steps={stepArray} />
            <div className={styles['controller-footer__rctrl']}>
                {hasSkip && (
                    <Button typeButton="secondary-ghost" onClick={onSkip}>
                        {i18n?.extraKeys?.Skip}
                    </Button>
                )}
                {hasBack && (
                    <Button
                        typeButton="secondary-outlined"
                        style={{ minWidth: 40, alignItems: 'center', display: 'flex', justifyContent: 'center' }}
                        icon={<XArrowIcon />}
                        onClick={onBack}
                    />
                )}
                {errorText ? (
                    <Popover content={<div className={styles['controller-footer-error']}>{errorText}</div>}>
                        {nextButton}
                    </Popover>
                ) : (
                    <>
                        {additionalText && (
                            <span className={styles['controller-footer-additionalText']}>{additionalText}</span>
                        )}
                        {nextButton}
                    </>
                )}
            </div>
        </div>
    )
}

export default ControllerFooterDesktop
